import React, { Component } from 'react';
import './Footer.css';

class Footer extends Component {
    render() {
      return (
        <footer>
        <p></p>
    </footer>
      );
    }
  }
  
  export default Footer;